import Repository from '@/repositories/marketing'
const resource = '/footers'

export default {
    fetch (config) {
        return Repository.get(`${resource}.json`, config)
    },
    delete (id) {
        return Repository.delete(`${resource}/${id}.json`)
    },
    setDefaultFooter (payload) {
        return Repository.put('update.json', payload)
    },
    showDefaultFooter (config) {
        return Repository.get('show.json', config)
    },
    preview (id, config) {
        return Repository.get(`${resource}/${id}.json`, config)
    },
    create (payload, config) {
        return Repository.post(`${resource}.json`, payload, config)
    },
    update (id, payload) {
        return Repository.put(`${resource}/${id}.json`, payload)
    },
    getHtmlJsonPart(config){
        return Repository.get(`${resource}/new.json`, config) 
    },
    validateName(config){
        return Repository.get(`${resource}/validate_name.json`, config) 
    }
}
